<template>
  <div v-if="setupPanel" :id="setupPanel.id" class="leave-content">
    <div class="content-header">
      <p v-html="setupPanel.title" />
    </div>

    <div v-if="setupPanel.month != 'disable'" class="content-subheader">
      <p v-html="setupPanel.month ? setupPanel.month : thisMonthNow" />
    </div>

    <div v-if="setupPanel.child" class="content-outer">
      <div
        v-for="child in setupPanel.child"
        :key="child"
        class="content-inner"
        :class="{
            'content-inner-waiting' : (child.container_color == 'yellow'),
            'content-inner-approve' : (child.container_color == 'green'),
            'content-inner-reject' : (child.container_color == 'red')
          }
        "
      >
        <div class="inner-header">
          <p v-html="child.title" />
        </div>

        <div v-if="loadData" class="inner-list">
          <div v-for="data in 2" :key="data" class="inner-list-load"></div>
        </div>

        <div v-else-if="!loadData && (child.dataShow.length == 0)" class="inner-list">
          <div class="inner-list-null">
            {{ setupPanel.no_data ? setupPanel.no_data : "No data for this month!" }}
          </div>
        </div>

        <div v-else-if="!loadData && (child.dataShow.length != 0)" class="inner-list">
          <div
            v-for="data in child.dataShow"
            :key="data"
            @click="openDetail(data)"
            class="inner-list-detail"
            :class="{'inner-list-detail-green' : (child.dataCondition == 'nextYear') && (Number(data.filterYear) > Number(thisYearNow)) }"
          >
            <p v-if="data.value1" v-html="data.value1" class="list-name" />
            <p v-if="data.value4" v-html="data.value4" class="list-subject" />
            <p v-if="data.value2" v-html="data.value2" class="list-info" />
            <p v-if="data.value3" v-html="data.value3" class="list-date"/>
            <p v-if="data.value5" v-html="data.value5" class="list-action"/>
            <p v-if="data.title" class="list-title" v-html="data.title" />
            <div v-if="data.value" class="list-value" v-html="data.value" />
          </div>
        </div>

        <div class="buttons-container">
          <div @click="openModal(child.id, true, formatList(child))" class="button-general button-primary" :class="{'button-frezee' : loadData}">
            <p>See All</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import { defineComponent, ref, reactive, onBeforeMount, onMounted, watch, watchEffect, computed } from "vue"
  import { useRouter, useRoute } from "vue-router"
  import { useI18n } from 'vue-i18n'
  import { useStore } from 'vuex'
  import axios from 'axios'
  import dayjs from 'dayjs'

  export default {
    components: {

    },

    props: {
      loadData: { type: Boolean, default: false },
      setupPanel: { type: Object, default: {} },
    },

    setup(props, { emit }) {
      const { t, locale } = useI18n()
      const router = useRouter()
      const route = useRoute()
      const store = useStore()


      const monthsId = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"]
      const monthsEn = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      const shortMonthsId = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"]
      const shortMonthsEn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Agu", "Sep", "Oct", "Nov", "Dec"]
      const daysId = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
      const daysEn = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

      function formatDate(type, date, dateSec) {
        const start = new Date(date)
        const end = new Date(dateSec)

        const day = start.getDate()
        const month = start.getMonth()
        const year = start.getFullYear()
        const dayOfWeek = start.getDay()

        const months = locale.value == 'id' ? monthsId : monthsEn
        const monthsShort = locale.value == 'id' ? shortMonthsId : shortMonthsEn
        const days = locale.value == 'id' ? daysId : daysEn
        // const daysShort = locale.value == 'id' ? shortDaysId : shortDaysEn

        if(type == 'dateTime') {
          return `${daysEn[dayOfWeek]}, ${day} ${monthsEn[month]} ${year}`
        }
        else if(type == 'monthYear') {
          return `${monthsEn[month]} ${year}`
        }
        else if(type == 'month') {
          return `${monthsEn[month]}`
        }
        else if(type == 'monthNum') {
          return `${month}`
        }
        else if(type == 'date') {
          return `${day} ${monthsEn[month]} ${year}`
        }
        else if(type == 'day') {
          return `${day}`
        }
        else if (type == 'event') {
          const endDay = end.getDate()
          const endMonth = end.getMonth()
          const endYear = end.getFullYear()

          const startTime = start.toLocaleTimeString('id-ID', {
            hour: '2-digit', minute: '2-digit', hour12: false
          }).replace(":", ".")

          const endTime = end.toLocaleTimeString('id-ID', {
            hour: '2-digit', minute: '2-digit', hour12: false
          }).replace(":", ".")

          const isZeroTime = startTime === "00.00" && endTime === "00.00"
          const timeRange = isZeroTime ? "" : ` (${startTime} - ${endTime})`

          if (day === endDay && month === endMonth && year === endYear) {
            return `${days[dayOfWeek]}, ${day} ${monthsShort[month]} ${year}${timeRange}`
          } else if (month === endMonth && year === endYear) {
            return `${day} - ${endDay} ${monthsShort[month]} ${year}${timeRange}`
          } else {
            return `${day} ${monthsShort[month]} - ${endDay} ${monthsShort[endMonth]} ${endYear}${timeRange}`
          }
        }
      }


      const thisMonthNow = ref("")
      const thisYearNow = ref("")
      const getDate = () => {
        const thisDate = new Date()
        let thisYear = thisDate.getFullYear()
        let thisMonth = thisDate.getMonth() + 1
        let thisDay = thisDate.getDate()
        let thisHours = thisDate.getHours()
        let thisMinutes = thisDate.getMinutes()
        let thisSeconds = thisDate.getSeconds()
        thisMonth = thisMonth <= 9 ? `${thisMonth}`.padStart(2, 0) : thisMonth
        thisDay = thisDay <= 9 ? `${thisDay}`.padStart(2, 0) : thisDay
        thisHours = thisHours <= 9 ? `${thisHours}`.padStart(2, 0) : thisHours
        thisMinutes = thisMinutes <= 9 ? `${thisMinutes}`.padStart(2, 0) : thisMinutes
        thisSeconds = thisSeconds <= 9 ? `${thisSeconds}`.padStart(2, 0) : thisSeconds
        const dateNow = thisYear + '-' + thisMonth + '-' + thisDay + ' ' + thisHours + ':'+ thisMinutes + ':' + thisSeconds

        thisMonthNow.value = formatDate('monthYear', dateNow)
        thisYearNow.value = thisYear
      }


      function formatList(data) {
        const monthNames = [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ]
        const groupedData = {}

        data.dataFull.forEach(item => {
          const dateObj = new Date(item.forFormatDate)
          const year = dateObj.getFullYear().toString()
          const monthIndex = dateObj.getMonth()
          const monthName = monthNames[monthIndex]

          if (!groupedData[year]) {
            groupedData[year] = {}
          }


          if (!groupedData[year][monthName]) {
            groupedData[year][monthName] = {
              data: [],
              index: monthIndex
            }
          }

          groupedData[year][monthName].data.push(item)
        })

        const result = Object.entries(groupedData)
        .sort((a, b) => b[0] - a[0])
        .map(([year, months]) => {
          const sortedMonths = Object.entries(months)
            .sort((a, b) => b[1].index - a[1].index)
            .map(([month_name, { data }]) => ({
              month_name,
              data
            }))

          return {
            year,
            month: sortedMonths
          }
        })

        return result
      }


      const openModal = (type, status, data) => {
        // console.log("cek list pertama", type, status, data)
        emit("open-modal", {type, status, data})
      }

      const openDetail = (data) => {
        emit("open-detail", data)
      }


      onMounted(() => {
        getDate()
      })


      return {
        thisMonthNow,
        thisYearNow,
        formatList,
        openModal,
        openDetail
      }
    }
  }
</script>
